import { Component, OnInit, Input } from '@angular/core';
import * as moment from 'moment';

import { DataStoreService } from '../../../services/common/data-store.service';
import { EventService } from '../../../services/events/event.service';
import { NotyService } from '../../../services/common/noty.service';

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.css'],
})
export class EventComponent implements OnInit {
  @Input() event_id: number;

  event_obj: any = {};

  loading: boolean = true;

  start: any;
  end: any;
  time_difference: string;
  title: any;

  constructor(private dataStoreService: DataStoreService, private eventService: EventService, private notyService: NotyService) {}

  /**
   * Called on component initialization
   */
  ngOnInit() {
    if (this.event_id)
      this.eventService.get(this.event_id).then((response_json) => {
        this.loading = false;
        this.event_obj = response_json;
        this.start = this.eventService.addOffset(moment(this.event_obj.start), this.event_obj.s_offset);
        this.end = this.eventService.addOffset(moment(this.event_obj.end), this.event_obj.e_offset);
        this.title = this.eventService.formatEventTitleFullDate(this.start, this.end, false, this.event_obj.all_day, true);
        if (this.event_obj.all_day) this.time_difference = 'All day';
        else this.time_difference = moment.duration(this.end - this.start).humanize();
        if (this.event_obj.reminder) this.event_obj.reminderFormat = this.eventService.formatEventReminder(this.event_obj.reminder);
        this.event_obj.rruleFormat = this.eventService.formatEventRrule(this.event_obj.rrule);
      });
  }

  /**
   * Open reminder using a reminder component
   * @param {number} reminder_id id of reminder to open
   */
  openReminder(reminder_id: number) {
    let reminderComponent: any = this.dataStoreService.retrieveStoreValues('reminderStore')[0];
    if (reminderComponent) reminderComponent.loadReminder(reminder_id, true);
    else this.notyService.notify('Error opening reminder', 'warning', 5000, 'center');
  }
}
